// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Vgc6S","icon":"styles_icon__YWv_B","message":"styles_message__MLQto"};